// extracted by mini-css-extract-plugin
export var backdrop = "styles-module--backdrop--31d67";
export var container = "styles-module--container--05bf1";
export var content = "styles-module--content--34ae6";
export var innerSidebar = "styles-module--innerSidebar--22350";
export var opened = "styles-module--opened--1a375";
export var side = "styles-module--side--a7db1";
export var sideToggle = "styles-module--sideToggle--54d76";